import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {
  GoBackView,
  GoBackViewProps,
} from '../../../features/GoBackView/GoBackView';
import {useLinksSection} from '../useGetProductBulkSection';

export const GoBack: React.FC<GoBackViewProps> = props => {
  return (
    <DataFetcher
      request={useLinksSection()}
      Error={null}
      View={GoBackView}
      viewProps={props}
    />
  );
};
